import { render, staticRenderFns } from "./PictureInput.vue?vue&type=template&id=8c42c4b0&scoped=true&"
import script from "./PictureInput.vue?vue&type=script&lang=js&"
export * from "./PictureInput.vue?vue&type=script&lang=js&"
import style0 from "./PictureInput.vue?vue&type=style&index=0&id=8c42c4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c42c4b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFileInput,VHover,VIcon})
